import axios from "axios";

export const base_external = "https://studio.postreality.io";

export const createUserFeedbackApi = (category: string, text: string) =>
  axios
    .post(`/api/v1/user_feedback/create`, { category, text })
    .then(res => res.data.user_feedback);
